import { useAppSelector } from "../../../../lib/redux/hooks";
import { ListItemNoProtM024 } from "./itemsNoProt/item";

interface Props {
    documentType: 'VALUTAZIONE' | 'RIESAME' | 'DECISIONE'
}

export function OtherProtM024List(props: Props) {
    const { documentType } = props
    const m024State = useAppSelector(state => state.m024)
    console.log('allo3w no attach', m024State.activeM024DetailNoAttachsUpdateRequest)
    const noAttachments = [
        {
            id: '1',
            attachmentName: "Provvedimento/i emesso/i a carico dell'operatore o del Gruppo di operatori (Stato)",
            numOfDetails: 2,
            code: undefined
        },
        {
            id: '2',
            attachmentName: "	Richiesta di integrazione documentale (Stato)",
            numOfDetails: 2,
            code: undefined
        }
    ]

    return (
        <div>
            {
                noAttachments.map((ca, index) => (
                    <div className="pb-3" key={ca.id}>
                        {m024State.activeM024DetailNoAttachsUpdateRequest.filter(det => det.entryProtocolId === ca.id).map(d => d.id)}
                        <ListItemNoProtM024
                            documentType={documentType}
                            id={ca.id || ''}
                            code={ca.code}
                            title={ca.attachmentName}
                            protocolIds={m024State.activeM024DetailNoAttachsUpdateRequest.filter(det => det.otherAttachmentId === ca.id).map(d => d.id)}
                            numOfDetails={ca.numOfDetails}
                        // numOfDetails={m024State.activeM024DetailsUpdateRequest.filter(det => det.entryProtocolAttachmentId === ca.id).length}
                        // protocolIds={m024State.activeM024DetailsUpdateRequest.filter(det => det.entryProtocolAttachmentId === ca.id).map(d => d.id)}
                        />
                    </div>
                ))
            }
        </div>
    )
}